
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';

export const UserLogin: React.FC = () => {
  const { toast } = useToast();
  const [isLoginForm, setIsLoginForm] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    // This is just a mock login functionality
    // In a real app, you'd integrate with an authentication provider
    setTimeout(() => {
      setIsLoading(false);
      toast({
        title: isLoginForm ? "Logged in successfully" : "Account created successfully",
        description: "You can now track and save your fasting progress.",
      });
    }, 1500);
  };

  if (!isLoginForm) {
    return (
      <div className="text-center">
        <h3 className="text-lg font-medium mb-2">Save Your Progress</h3>
        <p className="text-muted-foreground mb-4">
          Create an account to track and save your fasting history
        </p>
        <Button variant="outline" onClick={() => setIsLoginForm(true)}>
          Login / Sign Up
        </Button>
      </div>
    );
  }

  return (
    <Card className="w-full max-w-md mx-auto">
      <CardHeader>
        <CardTitle>{isLoginForm ? 'Login' : 'Create Account'}</CardTitle>
        <CardDescription>
          {isLoginForm 
            ? 'Sign in to save your fasting progress' 
            : 'Create an account to track your fasting journey'
          }
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input 
              id="email" 
              type="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required 
              placeholder="your@email.com"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input 
              id="password" 
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="pt-2">
            <Button type="submit" className="w-full" disabled={isLoading}>
              {isLoading ? 'Processing...' : isLoginForm ? 'Login' : 'Create Account'}
            </Button>
          </div>
          <div className="text-center">
            <button 
              type="button"
              className="text-sm text-primary underline" 
              onClick={() => setIsLoginForm(prev => !prev)}
            >
              {isLoginForm 
                ? "Don't have an account? Sign up" 
                : "Already have an account? Login"
              }
            </button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};
